module.exports = __webpack_public_path__ + "img/QL_logo.fedf2a71.png";